import AxiosUtil from '../utils/axiosUtil';
import { BaseService } from './BaseService';

export const SmsSettlementService = (function () {
  let instance;
  const BASE_URI = '/apis/sms-settlements';
  const baseService = BaseService.getInstance(BASE_URI, 'smsSettlement');

  function init() {
    return {
      ...baseService,
      list: async function (params) {
        const queryString = Object.entries(params)
          .map((e) => e.join('='))
          .join('&');
        return await AxiosUtil.Async.get(BASE_URI, queryString);
      },
      summary: async function (params) {
        const queryString = Object.entries(params)
          .map((e) => e.join('='))
          .join('&');
        return await AxiosUtil.Async.get(BASE_URI + '/summary', queryString);
      },
      updateStatus: async function (data) {
        return await AxiosUtil.Async.put(BASE_URI, data);
      },
      updateUnitPrices: async function (data) {
        return await AxiosUtil.Async.put(BASE_URI + '/unit-prices', data);
      },
    };
  }

  return {
    getInstance: function () {
      if (!instance) instance = init();
      return instance;
    },
  };
})();
